import type { NavigationGuard } from 'vue-router'

import { config } from '@/lib/helpers/config.helpers'
import { useAuthStore } from '@/stores/auth.stores'

export const registrationRedirect: NavigationGuard = async (to) => {
  const authStore = useAuthStore()
  const isAuthenticated = await authStore.authenticate()

  if (isAuthenticated) {
    return { name: 'overview' }
  }

  const identityAppLogin = new URL('/auth/registration', config.identityAppUrl)
  identityAppLogin.searchParams.append('app', 'advertiser')
  const returnUrl = new URL(to.fullPath, window.location.origin)
  identityAppLogin.searchParams.append('returnUrl', returnUrl.toString())

  if (to.query.role_code) {
    identityAppLogin.searchParams.append('invitation_code', String(to.query.role_code))
  }

  window.location.replace(identityAppLogin.toString())
  return false
}
